export const enumPermisosCrezcamos = Object.freeze({
  crezcamos_pago_creditos: 31000
});
